import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { Navigate } from 'react-router';

import { connect } from 'react-redux';

import ErrorContainer from 'Containers/ErrorContainer';

import ConsultationLoading from '../Scenes/ConsultationLoading';

import * as stylistActions from 'dux/stylist/actions';
import { getIsAuthenticating } from 'dux/auth/selectors';
import { getStylist, getStylistError, getStylistLoading } from 'dux/stylist/selectors';

// -----------------------------------------------------------------------
// StylistContainer
//
// This component will fetch stylist data in the appropriate moment and
// draw it's children only after the stylist data is available.
//
// -----------------------------------------------------------------------

const StylistContainer = ({
  children,
  error,
  isAuthenticating,
  isLoading,
  stylist,
  fetchAndTrySaveStylist,
}) => {
  const [stylistSlug] = useState(window.localStorage?.getItem('stylist')); // Similar to setState in constructor
  useEffect(() => {
    if (!isAuthenticating) {
      fetchAndTrySaveStylist();
    }
  }, [isAuthenticating, fetchAndTrySaveStylist]);

  if (error) {
    if (stylistSlug) {
      // Having a slug means stylist haven't been assigned to the user yet,
      //  in that case send user back to the vanity URL so it can handle the errors.
      return <Navigate replace to={`/stylist/${stylistSlug}`} />;
    }
    return (
      <ErrorContainer
        error={error}
        retry={fetchAndTrySaveStylist}
        sentryMessage="Invalid state on StylistContainer"
      />
    );
  }

  if (isLoading || !stylist) {
    return <ConsultationLoading />;
  }

  return children;
};

StylistContainer.propTypes = forbidExtraProps({
  children: PropTypes.node.isRequired,
  error: PropTypes.shape({}),
  fetchAndTrySaveStylist: PropTypes.func.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  stylist: PropTypes.shape({}),
});

StylistContainer.defaultProps = {
  error: null,
  stylist: null,
};

export default connect(
  state => ({
    error: getStylistError(state),
    isAuthenticating: getIsAuthenticating(state),
    isLoading: getStylistLoading(state),
    stylist: getStylist(state),
  }),
  {
    fetchAndTrySaveStylist: stylistActions.fetchAndTrySaveStylist,
  }
)(StylistContainer);
